import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { AiAssessedScore } from '../frontendServices/gameAPI';
import { SocketContext } from '../providers/SocketProvider/SocketProvider';

const useAiAssessedScores = ({
  gameId,
  slideId,
  tenantId,
  setShowMediaIsDisabled,
}: {
  gameId: string;
  slideId: string;
  tenantId: string;
  setShowMediaIsDisabled?: (val: boolean) => void;
}) => {
  const { gameAPI } = useContext(SocketContext);
  const client = useQueryClient();
  const scoresCacheKey = ['aiAssessedScores', gameId, slideId];
  const {
    mutate: generateAllAiAssessedScores,
    data: allAiAssessedScores,
    isLoading: isFetchingAiAssessedScores,
    error,
  } = useMutation(
    scoresCacheKey,
    async () => {
      if (!gameAPI) return Promise.resolve(undefined);
      return gameAPI.game.assessAiAnswers({
        gameId,
        slideId,
        tenantId,
      });
    },
    {
      onSuccess: newAiAssessedScore => {
        setShowMediaIsDisabled && setShowMediaIsDisabled(false);
        client.setQueryData<AiAssessedScore[] | undefined>(
          scoresCacheKey,
          previousScores => {
            if (!previousScores || !newAiAssessedScore) return previousScores;
            const updatedAiScores = newAiAssessedScore.results;
            return updatedAiScores;
          },
        );
      },
    },
  );

  return {
    generateAllAiAssessedScores,
    aiAssessedScores: allAiAssessedScores?.results,
    isFetchingAiAssessedScores,
    error: error,
  };
};

export default useAiAssessedScores;
